import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Vpc from './stretegies/VPCSETUP';
import Ipo from './stretegies/IPOBASE';
import Rocket from './stretegies/ROCKETBASE';
import Screenerdash from './Screenerdash';
import Fno from './stretegies/FNOSETUP';

const Scaner = () => {
  return (
    <Routes>
      <Route path="/" element={<Screenerdash />} />
      <Route path="vpc" element={<Vpc strategy="VPC SETUP" />} />
      <Route path="ipo" element={<Ipo strategy="IPO BASE" />} />
      <Route path="rocket" element={<Rocket strategy="ROCKET BASE" />} />
      <Route path="fno" element={<Fno strategy="FNO SETUP" /> } />
    </Routes>
  );
};

export default Scaner;
